<template>
    <basicSearch :onSearchApi="onSearchApi" placeholder="搜索" v-bind="$attrs" v-on="$listeners"></basicSearch>
</template>

<script>

import basicSearch from '@/components/basic/search.vue';
import { searchSpell } from '@/api/games/spell';


export default {
    name: "spell-search",
    components: {
        basicSearch
    },
    data () {
        return {
            onSearchApi: searchSpell,
        }
    }
}
</script>
